import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_31_contra_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Contra Voucher",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "contra_voucher",
        TableName: "vouchers",
        DisplayName: "vouchers",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Contra voucher details",
            BindValue: "con_contra_voucher_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "Voucher No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "txt_voucher_no",
                Json_Attribute: "voucher_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                AutoPopulate: true,
                IsReadOnly: true,
                AutoPopulate_format: "CO_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Voucher date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_voucher_date",
                Json_Attribute: "voucher_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                DefaultToday: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Voucher date is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Remarks",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_remarks",
                Json_Attribute: "narration",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Ref No.",
                PlaceHolder: "Ref No.",
                IsMandatory: false,
                BindValue: "txt_Ref_no",
                Json_Attribute: "ref_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Voucher type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_voucher_type_",
                Json_Attribute: "voucher_type",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                Default_Value: "Contra",
                IsReadOnly: true,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Reference date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_reference_date",
                Json_Attribute: "ref_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
                DefaultToday: true,
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Reference date is required",
                  },
                ],
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "voucher_details",
            label: "Contra voucher details",
            tableName: "voucher_details",
            lookupName: "",
            parentField: "txt_voucher_no",
            BindValue: "voucher_details",
            NotAllowEmpty:true,
            childControls: [
              {
                IncludeLabel: true,
                Label: "Credit ledger",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_from_ledger",
                Json_Attribute: "ledger_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "contra_ledgers",
                IsVerticalView: true,
                showInSummary: false,
                EnableEditForControl: false,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Credit ledger is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Credit narration",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_remarks",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: false,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Debit ledger",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_to_ledger",
                Json_Attribute: "to_ledger",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "contra_ledgers",
                IsVerticalView: true,
                showInSummary: false,
                EnableEditForControl: false,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Debit ledger is required",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Debit narration",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_to_narration",
                Json_Attribute: "to_narration",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: false,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_1",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_4",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Total Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_total_amount",
                Json_Attribute: "total_debit",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                Default_Value: "0",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        Label: "Submit",
        BindValue: "btn_submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
          textColor: "#FFFFFF",
          padding: 12,
          borderRadius: 8,
        },
      },
    ],
  },
];
